module.exports = __webpack_public_path__ + "img/bd86abd44b3a64cb1260049b595ec4ad.png";